var _path, _path2, _path3, _path4, _rect, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoundersCrownAmbassador(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_2122)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 100V0.499992C120 0.223854 119.776 0 119.5 0L98.4809 6.68791C97.8451 6.89018 97.1601 6.87479 96.5341 6.64416L79.1825 0.251459C78.7416 0.0890243 78.2576 0.0870054 77.8154 0.245756L60.0409 6.62634C59.3691 6.86751 58.6333 6.86123 57.9656 6.60862L41.1985 0.264281C40.748 0.0938411 40.2512 0.0916697 39.7993 0.258167L22.4932 6.6341C21.8505 6.87088 21.1461 6.88061 20.4971 6.66167L0.750003 0C0.335788 0 0 0.335783 0 0.749998V100C0 133.137 26.8629 160 60 160C93.1371 160 120 133.137 120 100Z",
    fill: "#8B88A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116 100V4.49999C116 4.22385 115.776 4 115.5 4L98.5586 10.5883C97.8765 10.8536 97.1209 10.8603 96.4342 10.6073L79.1825 4.25146C78.7416 4.08902 78.2576 4.08701 77.8154 4.24576L60.0409 10.6263C59.3691 10.8675 58.6333 10.8612 57.9656 10.6086L41.1985 4.26428C40.748 4.09384 40.2512 4.09167 39.7993 4.25817L22.6062 10.5925C21.8952 10.8544 21.1114 10.8376 20.4123 10.5454L4.75 4C4.33579 4 4 4.33578 4 4.75V100C4 130.928 29.0721 156 60 156C90.9279 156 116 130.928 116 100Z",
    fill: "#C1BDD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 20H111V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V20Z",
    fill: "url(#paint0_linear_12_2122)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111 28V12.4372C111 12.1958 110.804 12 110.563 12L96.9643 16.0596C96.3335 16.248 95.6581 16.2235 95.0425 15.9901L77.3765 9.29111C76.8846 9.10459 76.339 9.11937 75.858 9.33226L61.1533 15.8396C60.4157 16.166 59.5777 16.1817 58.8285 15.8831L42.2789 9.28694C41.8157 9.10233 41.3003 9.09739 40.8337 9.27309L23.0596 15.9654C22.3997 16.2138 21.6734 16.2219 21.0081 15.9882L9.65589 12C9.29365 12 9 12.2937 9 12.6559V28L57.4411 40.8226C59.1181 41.2666 60.8819 41.2666 62.5589 40.8226L111 28Z",
    fill: "#8B87A7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12_2122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_2122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 26,
    width: 159,
    height: 158
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 26,
    width: 70,
    height: 153,
    transform: "rotate(45 114 26)",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_2122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 25C9 18.3726 14.3726 13 21 13H99C105.627 13 111 18.3726 111 25V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V25Z",
    fill: "black",
    fillOpacity: 0.3
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23.4318C45 22.7367 45.6916 22.2536 46.3443 22.4929L59.6557 27.3738C59.878 27.4553 60.122 27.4553 60.3443 27.3738L73.6557 22.4929C74.3084 22.2536 75 22.7367 75 23.4318V25.3016C75 25.7211 74.7381 26.096 74.3443 26.2404L60.3443 31.3738C60.122 31.4553 59.878 31.4553 59.6557 31.3738L45.6557 26.2404C45.2619 26.096 45 25.7211 45 25.3016V23.4318Z",
    fill: "#C1BDD5"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9982 89L45.6503 69H51.0793L59.9982 80.7949V89Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9982 49L45.6503 69H51.0793L59.9982 57.2051V49Z",
    fill: "#F8F8F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9982 89L74.346 69H68.9171L59.9982 80.7949V89Z",
    fill: "#9F9F9F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9982 49L74.346 69H68.9171L59.9982 57.2051V49Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0869 68.9993L60.0058 57.2044L68.9248 68.9993L60.0058 80.7942L51.0869 68.9993Z",
    fill: "#E6E6E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63 91.7678L83 77.4199L83 82.8488L71.2051 91.7678L63 91.7678Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103 91.7678L83 77.4199L83 82.8488L94.7949 91.7678L103 91.7678Z",
    fill: "#F8F8F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63 91.7678L83 106.116L83 100.687L71.2051 91.7678L63 91.7678Z",
    fill: "#9F9F9F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103 91.7678L83 106.116L83 100.687L94.7949 91.7678L103 91.7678Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0007 82.8564L94.7955 91.7753L83.0007 100.694L71.2058 91.7753L83.0007 82.8564Z",
    fill: "#E6E6E6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57 91.7678L37 77.4199L37 82.8488L48.7949 91.7678L57 91.7678Z",
    fill: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17 91.7678L37 77.4199L37 82.8488L25.2051 91.7678L17 91.7678Z",
    fill: "#F8F8F8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57 91.7678L37 106.116L37 100.687L48.7949 91.7678L57 91.7678Z",
    fill: "#9F9F9F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17 91.7678L37 106.116L37 100.687L25.2051 91.7678L17 91.7678Z",
    fill: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9993 82.8564L25.2045 91.7753L36.9993 100.694L48.7942 91.7753L36.9993 82.8564Z",
    fill: "#E6E6E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9982 95L45.6503 115H51.0793L59.9982 103.205V95Z",
    fill: "#CCCCCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9982 135L45.6503 115H51.0793L59.9982 126.795V135Z",
    fill: "#F8F8F8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9982 95L74.346 115H68.9171L59.9982 103.205V95Z",
    fill: "#9F9F9F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9982 135L74.346 115H68.9171L59.9982 126.795V135Z",
    fill: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0869 115.001L60.0058 126.796L68.9248 115.001L60.0058 103.206L51.0869 115.001Z",
    fill: "#E6E6E6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6941 57.319C31.0695 55.7983 33.2313 55.7983 33.6067 57.319L34.4081 60.5654C34.5416 61.1063 34.964 61.5287 35.5049 61.6622L38.7513 62.4636C40.272 62.839 40.272 65.0008 38.7513 65.3762L35.5049 66.1776C34.964 66.3112 34.5416 66.7335 34.4081 67.2744L33.6067 70.5209C33.2313 72.0415 31.0695 72.0415 30.6941 70.5209L29.8927 67.2744C29.7591 66.7335 29.3368 66.3112 28.7959 66.1776L25.5494 65.3762C24.0288 65.0008 24.0288 62.839 25.5494 62.4636L28.7959 61.6622C29.3368 61.5287 29.7591 61.1063 29.8927 60.5654L30.6941 57.319Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6941 113.019C31.0695 111.498 33.2313 111.498 33.6067 113.019L34.4081 116.266C34.5416 116.807 34.964 117.229 35.5049 117.362L38.7513 118.164C40.272 118.539 40.272 120.701 38.7513 121.076L35.5049 121.878C34.964 122.011 34.5416 122.434 34.4081 122.975L33.6067 126.221C33.2313 127.742 31.0695 127.742 30.6941 126.221L29.8927 122.975C29.7591 122.434 29.3368 122.011 28.7959 121.878L25.5494 121.076C24.0288 120.701 24.0288 118.539 25.5494 118.164L28.7959 117.362C29.3368 117.229 29.7591 116.807 29.8927 116.266L30.6941 113.019Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3933 57.319C86.7687 55.7983 88.9305 55.7983 89.3059 57.319L90.1073 60.5654C90.2409 61.1063 90.6632 61.5287 91.2041 61.6622L94.4505 62.4636C95.9712 62.839 95.9712 65.0008 94.4505 65.3762L91.2041 66.1776C90.6632 66.3112 90.2409 66.7335 90.1073 67.2744L89.3059 70.5209C88.9305 72.0415 86.7687 72.0415 86.3933 70.5209L85.5919 67.2744C85.4583 66.7335 85.036 66.3112 84.4951 66.1776L81.2486 65.3762C79.728 65.0008 79.728 62.839 81.2486 62.4636L84.4951 61.6622C85.036 61.5287 85.4583 61.1063 85.5919 60.5654L86.3933 57.319Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3933 113.019C86.7687 111.498 88.9305 111.498 89.3059 113.019L90.1073 116.266C90.2409 116.807 90.6632 117.229 91.2041 117.362L94.4505 118.164C95.9712 118.539 95.9712 120.701 94.4505 121.076L91.2041 121.878C90.6632 122.011 90.2409 122.434 90.1073 122.975L89.3059 126.221C88.9305 127.742 86.7687 127.742 86.3933 126.221L85.5919 122.975C85.4583 122.434 85.036 122.011 84.4951 121.878L81.2486 121.076C79.728 120.701 79.728 118.539 81.2486 118.164L84.4951 117.362C85.036 117.229 85.4583 116.807 85.5919 116.266L86.3933 113.019Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2122",
    x1: 60,
    y1: 20,
    x2: 60,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#352042"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_2122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 160,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12_2122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 122,
    fill: "white",
    transform: "translate(9 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundersCrownAmbassador);
export default __webpack_public_path__ + "static/media/foundersCrownAmbassador.ff53f93c9f389b9ab1550135b434d1f7.svg";
export { ForwardRef as ReactComponent };